import * as React from "react";
import { Navigate } from "react-router-dom";
import { SetupParsedLocation } from "./mobxStores/parsedLocation/setupParsedLocation";
import { useAppSelector } from "./store/hooks";
import { selectIsLoggedIn } from "./store/userSlice";
import { Layout } from "./layout";

interface Props extends React.PropsWithChildren {
  onMount?: () => void;
  onClear?: (onMountRes: any) => void;
}
export const PrivateRouteDelayed: React.FC<Props> = ({ children, onMount, onClear }) => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  const [counter, setCounter] = React.useState(0);
  const isReady = counter >= 3;

  React.useEffect(() => {
    let onMountRes: any = null;
    if (onMount) {
      onMountRes = onMount();
    }
    setCounter(1);

    return () => {
      if (onClear) {
        onClear(onMountRes);
      }
    };
  }, []);

  React.useEffect(() => {
    if (counter === 0) {
      return;
    }
    if (isReady) {
      return;
    }
    setCounter(counter + 1);
  }, [counter]);

  if (!isReady) {
    return <Layout />;
  }

  if (!isLoggedIn) {
    return <Navigate to={"/signin"} />;
  }

  return (
    <>
      <SetupParsedLocation />
      {children}
    </>
  );
};
